__turbopack_context__.v({
  "single": "SortControl-module-scss-module__6d0HKq__single",
  "sort": "SortControl-module-scss-module__6d0HKq__sort",
});
